import React, { Component } from 'react';
import Immutable from 'immutable';
import { withStyles } from '@material-ui/core/styles';
// import Box from "@material-ui/core/Box";
import clsx from 'clsx';
import Typography from '@material-ui/core/Typography';
// import Button from "@material-ui/core/Button";
import Grid from '@material-ui/core/Grid';
import { formatDate } from 'helpers/stringUtils';
import combine from 'mout/array/combine';
import filter from 'mout/array/filter';
// import BlockTitle from "components/UI/BlockTitle";
// import EventCardSimple from "components/Event/EventCardSimple";
// import ArrowRightAltIcon from "@material-ui/icons/ArrowRightAlt";
import CheckBoxIcon from '@material-ui/icons/CheckBox';
import CheckBoxOutlineBlankIcon from '@material-ui/icons/CheckBoxOutlineBlank';
import EventTimeGrid from './EventTimeGrid';
// import EventSubscription from "components/EventSubscription/EventSubscription";
// import PopinWrapper from "components/PopinWrapper";
// import EventSubscriptionVisitor from "components/EventSubscription/EventSubscriptionVisitor";
// import EventSubscriptionFor from "components/EventSubscription/EventSubscriptionFor";
// import DialogPopinButton from "components/UI/Dialog/DialogPopinButton";
import Paper from '@material-ui/core/Paper';
import { withRouter } from 'react-router-dom';
// import i18n from "helpers/i18n";
const SINGLE_EVENT_SUBSCRIPTION = true;
const styles = (theme) => {
  return {
    root: {
      // maxWidth: 1280,
      // margin: "0 auto 30px",
      '& .MuiTypography-subtitle1': {
        color: '#fff',
        fontSize: '1rem',
        display: 'block',
        textAlign: 'center',
        width: '100%',
        fontWeight: 'bold',
      },
      '& .MuiTypography-subtitle2': {
        color: '#fff',
        fontSize: '1.5rem',
        display: 'block',
        textAlign: 'center',
        width: '100%',
        fontWeight: 'bold',
      },
    },
    dateItem: {
      cursor: 'pointer',
    },
    dateWrapper: {
      padding: 10,
      backgroundColor: theme.palette.primary.main,
      width: 250,
      height: 250,
      transition: [
        theme.transitions.create('background-color', {
          easing: theme.transitions.easing.sharp,
          duration: theme.transitions.duration.leavingScreen,
        }),
        theme.transitions.create('color', {
          easing: theme.transitions.easing.sharp,
          duration: theme.transitions.duration.leavingScreen,
        }),
      ],
      '& .MuiTypography-body1': {
        fontSize: '14px',
        lineHeight: '22px',
        letterSpacing: '1.17px',
        fontStyle: 'normal',
        // color: theme.palette.common.black,
        // fontWeight: 'bold',
        [theme.breakpoints.down('sm')]: {
          fontSize: '12px',
          lineHeight: '16px',
        },
      },
    },
    dateWrapperSelected: {
      backgroundColor: theme.palette.secondary.main,
      '& .MuiTypography-subtitle1, .MuiTypography-subtitle2 ': {
        color: theme.palette.text.light,
      },
    },
    dateWrapperActions: {
      padding: '0',
    },
    dateWrapperActionsButton: {
      transition: [
        theme.transitions.create('color', {
          easing: theme.transitions.easing.sharp,
          duration: theme.transitions.duration.leavingScreen,
        }),
        theme.transitions.create('opacity', {
          easing: theme.transitions.easing.sharp,
          duration: theme.transitions.duration.leavingScreen,
        }),
      ],
      backgroundImage: 'none',
      color: theme.palette.text.light,
      backgroundColor: theme.palette.primary.main,
      fontSize: 22,
      fontWeight: 'bold',
      letterSpacing: '1px',
      padding: '0px 20px',
      border: '1px transparent solid',
      display: 'flex',
      '&:hover': {
        backgroundImage: 'none',
        border: '1px #fff solid',
        backgroundColor: '#fff',
        color: theme.palette.primary.main,
      },
    },
    subscriptionState: {
      position: 'absolute',
      right: 5,
      top: 5,
    },
    inline: {
      display: 'inline-block',
    },
    disabled: {
      opacity: 0.5,
    },
  };
};
class EventSelector extends Component {
  constructor(props) {
    super(props);
    this.state = {
      currentCard: 0,
      selected: [],
    };
    this._redirTo = this._redirTo.bind(this);
    this._onToggleCardSelect = this._onToggleCardSelect.bind(this);
    // this._onSubscriptionComplete = this._onSubscriptionComplete.bind(this);
    this._onSelectionComplete = this._onSelectionComplete.bind(this);
  }
  componentDidMount() {
    this._setSubscriptions();
  }
  componentDidUpdate(oldProps, oldState) {
    if (oldState.selected.length === 0 && oldProps.$$subscriptions.size !== this.props.$$subscriptions.size) {
      this._setSubscriptions();
    }
  }
  _onSelectionComplete() {
    const { onSelectionComplete } = this.props;
    const $$selectedCards = this._getSelectedCards();
    onSelectionComplete($$selectedCards);
  }
  _setSubscriptions() {
    const { $$subscriptions, $$data } = this.props;
    if ($$subscriptions.size > 0) {
      let arr = [];
      $$subscriptions.map(($s) => arr.push($s));
      this.setState({
        selected: arr,
      });
    } else {
      if ($$data !== undefined && $$data.size === 1 && $$data.get(0).get('isFull') !== 1)
        this._onToggleCardSelect($$data.get(0).get('id'));
      // console.log("meh", $$data.get(0).toJS());
    }
  }
  _redirTo(url) {
    const { history } = this.props;
    history.push(url);
  }
  _getCard() {
    const { $$data } = this.props;
    const { currentCard } = this.state;
    if ($$data === undefined) return false;
    else {
      const c = $$data.filter((d) => d.get('id') === currentCard).get(0);
      if (c !== undefined) {
        return c;
      } else if ($$data.get(0) !== undefined) {
        return $$data.get(0);
      } else return false;
    }
  }
  _onToggleCardSelect(cardId) {
    const { selected } = this.state;
    let newSelected = combine([], selected);
    const k = newSelected.indexOf(cardId);
    // console.log('found?',k, cardId, newSelected)
    // console.log('l',selected.length)
    if (SINGLE_EVENT_SUBSCRIPTION === true) newSelected = [];
    if (k >= 0) newSelected = filter(newSelected, (s) => s !== cardId);
    else newSelected.push(cardId);
    // console.log('l',newSelected.length)
    this.setState(
      {
        selected: newSelected,
        currentCard: cardId,
      },
      () => {
        this._onSelectionComplete();
      },
    );
  }
  _onSubscriptionComplete(r) {
    const { onSubscriptionComplete } = this.props;
    this.setState(
      {
        isLoggingIn: false,
      },
      () => {
        onSubscriptionComplete(r);
      },
    );
  }
  _getSelectedCards() {
    const { $$data } = this.props;
    const { selected } = this.state;
    const $$selectedCards =
      $$data !== undefined ? $$data.filter((d) => selected.indexOf(d.get('id')) >= 0) : Immutable.fromJS([]);
    return $$selectedCards;
  }
  render() {
    const { $$data, userRole, classes, $$subscriptions } = this.props;
    const { selected } = this.state;
    // const $$card = this._getCard();
    // const $$selectedCards = this._getSelectedCards();
    // console.log($$selectedCards.toJS())
    // if ($$subscriptions !== undefined)
    // let isSubscribed;
    // console.log(isLoggingIn)
    return (
      <If condition={$$data !== undefined}>
        <Grid container item spacing={2} xs={12} justify="center" className={classes.root} align="center">
          {$$data
            .map(($$card, cardIdx) => {
              return (
                <EventTimeGrid
                  key={'k_' + cardIdx}
                  $$card={$$card}
                  selected={selected.indexOf($$card.get('id')) >= 0}
                  subscribed={$$subscriptions.contains($$card.get('id'))}
                  onClick={this._onToggleCardSelect}
                />
              );
            })
            .toArray()}
        </Grid>
      </If>
    );
  }
}
// export default ;
export default withRouter(withStyles(styles)(EventSelector));



// WEBPACK FOOTER //
// ./src/components/Event/EventSelector.jsx